import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  GRIN_SCOPE_TYPE_REGULAR,
  GRIN_SCOPE_TYPE_MINI,
  GRIN_SCOPE_TYPE_LG,
  GRIN_SCOPE_TYPE_LG_MINI
} from 'consts/billingConsts'

import OrderGrinKitInfo from './OrderGrinKitInfo'
import { getScopeProductsContent } from './scopeProducts'

const ScopeDescriptionPopup = ({ type }) => {
  const { t } = useTranslation()
  const scopeProducts = getScopeProductsContent(t)
  const toPopupContent = scopeType => ({
    title: scopeProducts[scopeType].name,
    subTitle: scopeProducts[scopeType].selectorDescription,
    scopeImage: scopeProducts[scopeType].comparisonImage,
    arrowImage: scopeProducts[scopeType].comparisonArrowImageMobile,
    width: scopeProducts[scopeType].comparisonWidth,
    description: scopeProducts[scopeType].comparisonDescription
  })
  const scope = {
    [GRIN_SCOPE_TYPE_REGULAR]: toPopupContent(GRIN_SCOPE_TYPE_REGULAR),
    [GRIN_SCOPE_TYPE_MINI]: toPopupContent(GRIN_SCOPE_TYPE_MINI),
    [GRIN_SCOPE_TYPE_LG]: toPopupContent(GRIN_SCOPE_TYPE_LG),
    [GRIN_SCOPE_TYPE_LG_MINI]: toPopupContent(GRIN_SCOPE_TYPE_LG_MINI)
  }[type]

  return (
    <div>
      <OrderGrinKitInfo {...scope} />
    </div>
  )
}

export default ScopeDescriptionPopup
